import { render, staticRenderFns } from "./RealEstateTabs.vue?vue&type=template&id=2158edc4&"
import script from "./RealEstateTabs.vue?vue&type=script&lang=js&"
export * from "./RealEstateTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2158edc4')) {
      api.createRecord('2158edc4', component.options)
    } else {
      api.reload('2158edc4', component.options)
    }
    module.hot.accept("./RealEstateTabs.vue?vue&type=template&id=2158edc4&", function () {
      api.rerender('2158edc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/RealEstateTabs.vue"
export default component.exports